module.exports = __webpack_public_path__ + "img/favicon.4388644.png";